// [목적] 익명 사용자 식별자 lifecycle — 첫 방문 시 nanoid(16) 발급, localStorage 영속
// [이유] folio-crud BE 가드의 클라이언트 절반 (fe-screens-skeleton ADR-4 + Spec §4-6)
// [사이드 이팩트] localStorage `gangwon.anonSessionId` 키 점유. fetch wrapper가 매 요청에 헤더로 첨부
// [수정 시 고려사항] oauth-login Spec 진입 시 anon → user 클레임으로 본 ID는 백엔드에서 인계 후 클라이언트에서 폐기

import { customAlphabet } from 'nanoid';

const STORAGE_KEY = 'gangwon.anonSessionId';
const SESSION_LENGTH = 16;
const alphabet = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-_';
const nano = customAlphabet(alphabet, SESSION_LENGTH);

export function ensureAnonSessionId(): string {
  if (typeof window === 'undefined') return ''; // SSR no-op
  let id = window.localStorage.getItem(STORAGE_KEY);
  if (!id) {
    id = nano();
    window.localStorage.setItem(STORAGE_KEY, id);
  }
  return id;
}

export function clearAnonSessionId(): void {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(STORAGE_KEY);
  }
}
